export default __webpack_public_path__ + "static/media/banner_2.159b417b.jpg";